import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "CategoryFilter-panel" }
const _hoisted_2 = {
  key: 1,
  class: "CategoryFilter"
}
const _hoisted_3 = {
  key: 2,
  class: "CategoryFilter-resetContainer"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("svg", {
  width: "16",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 320 512"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    fill: "currentColor",
    d: "M207.6 256l107.72-107.72c6.23-6.23 6.23-16.34 0-22.58l-25.03-25.03c-6.23-6.23-16.34-6.23-22.58 0L160 208.4 52.28 100.68c-6.23-6.23-16.34-6.23-22.58 0L4.68 125.7c-6.23 6.23-6.23 16.34 0 22.58L112.4 256 4.68 363.72c-6.23 6.23-6.23 16.34 0 22.58l25.03 25.03c6.23 6.23 16.34 6.23 22.58 0L160 303.6l107.72 107.72c6.23 6.23 16.34 6.23 22.58 0l25.03-25.03c6.23-6.23 6.23-16.34 0-22.58L207.6 256z"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SpinnerGlobal = _resolveComponent("SpinnerGlobal")!
  const _component_FilterSection = _resolveComponent("FilterSection")!
  const _component_ButtonCloseFilter = _resolveComponent("ButtonCloseFilter")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["CategoryFilter ProductCategory-filter", {'CategoryFilter--horizontal': _ctx.horizontal, 'is-open': _ctx.isOpenedFilterModal}])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_SpinnerGlobal, { key: 0 }))
        : _createCommentVNode("", true),
      (!_ctx.horizontal)
        ? (_openBlock(), _createElementBlock("h2", _hoisted_2, _toDisplayString(_ctx.filterTitle), 1))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filter.sections, (filterSection) => {
        return (_openBlock(), _createBlock(_component_FilterSection, {
          key: filterSection.name,
          section: filterSection
        }, null, 8, ["section"]))
      }), 128)),
      (_ctx.isAppliedFilter)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("button", {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.clearFilter(null))),
              class: "CategoryFilter-reset",
              type: "button"
            }, [
              _hoisted_4,
              _createElementVNode("span", null, _toDisplayString(_ctx.cancelLabel), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: _normalizeClass({'CategoryFilter-controls': true, 'is-applied-filter': _ctx.isAppliedFilter})
    }, [
      _createVNode(_component_ButtonCloseFilter, {
        text: _ctx.applyOrCloseFilterLabel,
        onClick: _ctx.closeFilterModal
      }, null, 8, ["text", "onClick"])
    ], 2)
  ], 2))
}